import styled, { css } from "styled-components";

export const StyledBadge = styled.span`
    display: inline-flex;
    position: relative;
`;

export const StyledBadgeContent = styled.span`
    position: absolute;
    top: ${({ offsetTop }) => `${offsetTop ? offsetTop : 0}px`};
    right: ${({ offsetRight }) => `${offsetRight ? offsetRight : 0}px`};
    transform: translate(50%, -100%);
    transform-origin: 50% -50%;
    padding: 3px;
    border-radius: 50%;
    background-color: ${({ theme, red }) =>  `${red ? theme.colors.error : theme.colors.blue}` };
    transition: all 0.3s;
    ${({ size }) => size === "large" && css`
        padding: 5px;
    `};
    ${({ border }) => border && css`
        border: ${({ theme }) => `2px solid ${theme.colors.white}`};
    `};
    ${({ invisible }) => invisible && css`
        transform: translate(50%, 0) scale(0);
        visibility: hidden;
    `};
`;